// extracted by mini-css-extract-plugin
export default {"formFields":"AdminAuthenticationView-module__formFields--CpgZ+","formFooter":"AdminAuthenticationView-module__formFooter--I90CI"};